import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirTransferenciaMunicipio } from './types';

export const INITIAL_STATE: emitirTransferenciaMunicipio = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirTransferenciaMunicipio {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_REQUEST: {
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_MUNICIPIOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
